import {
  POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES,
  POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES,
} from '../../../../constants/infrastructure';
import { TInfrastructureItem } from '../../../../types/map';

export function isTransportAccessibilityInfrastructureItem(infrastructureItem: TInfrastructureItem) {
  const transportAccessibilityInfrastructureTypes = [
    ...POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES,
    ...POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES,
  ] as string[];

  return transportAccessibilityInfrastructureTypes.includes(infrastructureItem.type);
}
